import {useForm} from 'react-hook-form';
import {UpdateOrganization, updateOrganizationSchema} from '@tinct/core-api-models';
import {zodResolver} from '@hookform/resolvers/zod';
import {useGetOrganizationById, useUpdateOrganization} from '@tinct/core-api';
import {handleApiError} from '@tinct/web-form';

type UseCreateOrganizationBrandFormOptions = {
  organizationId: string | null;
  onSuccess?: () => void;
};

export const useUpdateOrganizationDomainForm = ({
  organizationId,
  onSuccess,
}: UseCreateOrganizationBrandFormOptions) => {
  const { data: organization, isLoading: isFetchingOrganization } = useGetOrganizationById(
    {
      id: organizationId as string,
      fields: {
        id: null,
        domain: null,
      },
    },
    { enabled: !!organizationId },
  );

  const form = useForm<UpdateOrganization>({
    resolver: zodResolver(updateOrganizationSchema),
    defaultValues: {
      domain: organization?.domain ?? '',
    },
    values: {
      domain: organization?.domain ?? '',
    }
  });

  const updateOrganization = useUpdateOrganization({
    onSuccess: () => {
      onSuccess?.();
    },
    onError: (error) => handleApiError(error, form),
  });

  const handleSubmit = form.handleSubmit(
    (data) => {
      updateOrganization.mutate({
        organizationId: organizationId as string,
        data
      });
    },
    (errors) => {
      console.error('[Zod Validation Errors]', errors);
    },
  );

  return {
    form,
    handleSubmit,
    isLoading: updateOrganization.isPending,
    isFetchingOrganization,
    organization,
    isError: updateOrganization.isError,
    error: updateOrganization.error,
  };
};
